import { create } from 'zustand'

export const useSiteHeader = create<{ title?: string }>(set => ({
  title: ''
}))
